import "./table-header.component.scoped.sass";
import React, { useState } from "react";
import { TableHeaderProps } from "../../types/table-header-props";
import { useTranslation } from "react-i18next";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { SorterComponent } from "../sorter/sorter.component";

export const TableHeaderComponent = (props: TableHeaderProps) => {
  const [rating, setRating]: any = useState(0);

  const { columns } = props;
  const { sort, search } = props.tools;
  const {
    sortDirection,
    sortColumn,
    searchColumn,
    searchString,
  } = props.options;
  const { withSort, withSearch } = props.options;
  const [t] = useTranslation();
  const doSearch = (fieldName: string, event: any): any => {
    const value = event.target.value;
    return search(fieldName, value);
  };

  const fillStars = (rate: any): any => {
    if (rating === rate) {
      setRating(0);
      search("rating", "");
    } else {
      setRating(rate);
      search("rating", rate);
    }
  };

  return (
    <div className="table-header bk-light-blue-grey">
      {columns.map((column, index) => {
        return (
          <div
            className={
              "one-column" +
              (column.type === "tasks"  || column.type === "locations" ? " flex-grow" : "") +
              (column.type === "actions" ? " actions" : "")
            }
            style={{ width: `${column.width || 270}px` }}
            key={index}
          >
            <div className="w-100">
              <div className="upper">
                <div className={"name " + column.value}>{t(column.value)}</div>
                {withSort &&
                  column.type !== "actions" &&
                  column.type !== "tasks" &&
                  column.type !== "locations" &&
                  column.type !== "activities-hours" && (
                    <SorterComponent
                      isSorting={column.fieldName === sortColumn}
                      direction={sortDirection}
                      sortColumn={sortColumn}
                      fieldName={column.fieldName}
                      sort={sort}
                    />
                  )}
              </div>
              {withSearch &&
                column.type !== "actions" &&
                column.type !== "average rating" && (
                  <div
                    className={
                      "lower" +
                      (column.type === "tasks" || column.type === "locations"
                        ? " flex-grow w-100"
                        : "")
                    }
                  >
                    {!column.secondaryValue ? (
                      <input
                        value={
                          searchColumn === column.fieldName ? searchString : ""
                        }
                        onChange={doSearch.bind(null, column.fieldName)}
                        className={`w-100 ${
                          column.type === "tasks" || column.type === "locations"
                            ? "flex-grow"
                            : ""
                        }`}
                        placeholder={t("search") + "..."}
                      />
                    ) : (
                      <div className="sec-value">
                        {t(column.secondaryValue)}
                      </div>
                    )}
                  </div>
                )}
              {column.type === "average rating" && (
                <div className="lower rating-head">
                  {Array(rating)
                    .fill(0)
                    .map((item: any, index: any) => (
                      <div
                        className="star"
                        key={index}
                        onClick={() => fillStars(index + 1)}
                      >
                        <StarIcon />
                      </div>
                    ))}
                  {Array(5 - rating)
                    .fill(0)
                    .map((item: any, index: any) => (
                      <div
                        className="empty-star"
                        key={index}
                        onClick={() => fillStars(rating + index + 1)}
                      >
                        <StarBorderIcon />
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
